import { render, staticRenderFns } from "./Homemain.vue?vue&type=template&id=b53b0ccc&scoped=true&"
var script = {}
import style0 from "./Homemain.vue?vue&type=style&index=0&id=b53b0ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53b0ccc",
  null
  
)

export default component.exports